import { Dashboard, BrokerLicenses } from '@/components';

export const BrokerLicensePage = (): JSX.Element => (
  <Dashboard>
    <BrokerLicenses />
  </Dashboard>
);
